import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DietitianState,
  DietitianStateProvider,
} from 'src/app/data/dietitian/domain/dietitian_state_provider';
import {
  PatientGroup,
  PatientGroupProps,
} from 'src/app/data/dietitian/domain/patient_group/patient_group';
import { PatientGroupCommands } from 'src/app/data/dietitian/domain/patient_group/patient_group_commands';

@Injectable()
export class EditPatientGroupFacade {
  isLoading = false;

  constructor(
    private dietitianStateProvider: DietitianStateProvider,
    private patientGroupCommands: PatientGroupCommands,
  ) {
    // do nothing
  }

  get accountStatus$(): Observable<DietitianState> {
    return this.dietitianStateProvider.state$;
  }

  getPatientGroup(patientGroupId: string): Promise<PatientGroup> {
    return this.patientGroupCommands.getPatientGroup(patientGroupId);
  }

  savePatientGroup(
    patientGroupProps: PatientGroupProps,
    patientGroupId?: string,
  ): Promise<PatientGroup> {
    return this.patientGroupCommands.savePatientGroup(
      patientGroupProps,
      patientGroupId,
    );
  }
}
